'use strict';

import { listenDOMEvent } from '@jspartials/dom-api-utils';
import { addToList } from '@jspartials/general-utils';
import {
  classes,
  addClassToElement,
  removeClassToElement
} from '@jspartials/class-list-utils';

// Selectors
const selector = {
  videoProductsCarousel: {
    wrapper: '.js-video-products-carousel',
    list: '.js-video-products-carousel__list',
    item: '.js-video-products-carousel__item',
    navigationButton: '.js-video-products-carousel__navigation-button'
  }
};

// Variables
const listOfVideoProductsCarousel = [];
const itemsToMove = 4; // Same as the color variants navigation

// Functions

/**
 * Listen video products carousel elements
 * @returns {void}
 */
const listenVideoProductsCarousel = () => {
  const carousels =
    document.querySelectorAll(selector.videoProductsCarousel.wrapper) || [];

  if (carousels.length > 0) {
    carousels.forEach((carousel) => {
      if (!listOfVideoProductsCarousel.includes(carousel)) {
        addToList(carousel, listOfVideoProductsCarousel);
        listenVideoProductsCarouselNavigation(carousel);
      }
    });
  }
};

/**
 * Listen the navigation buttons and the scroll of the carousel
 * @param {HTMLElement} carousel - Carousel element
 * @returns {void}
 */
const listenVideoProductsCarouselNavigation = (carousel) => {
  const list =
    carousel.querySelector(selector.videoProductsCarousel.list) || null;
  const navigationButtons = carousel.querySelectorAll(
    selector.videoProductsCarousel.navigationButton
  );

  if (!list || navigationButtons.length === 0) {
    return;
  }

  navigationButtons.forEach((navigationButton) => {
    listenDOMEvent(navigationButton, 'click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      navigate(list, navigationButton.dataset.direction);
    });
  });

  listenDOMEvent(list, 'scroll', () => {
    updateNavigationButtons(list, navigationButtons);
  });

  updateNavigationButtons(list, navigationButtons);
};

/**
 * Move the list a fixed number of items
 * @param {HTMLElement} list - List element
 * @param {String} direction - Direction to navigate (left or right)
 * @returns {void}
 */
const navigate = (list, direction) => {
  const item = list.querySelector(selector.videoProductsCarousel.item) || null;
  const gap = parseFloat(getComputedStyle(list).columnGap) || 0;
  const itemWidth = item ? item.offsetWidth + gap : 0;
  const distance = itemWidth * itemsToMove;

  list.scrollBy({
    left: direction === 'left' ? -distance : distance,
    behavior: 'smooth'
  });
};

/**
 * Show or hide the navigation buttons depending on the scroll position
 * @param {HTMLElement} list - List element
 * @param {NodeList} navigationButtons - Navigation button elements
 * @returns {void}
 */
const updateNavigationButtons = (list, navigationButtons) => {
  const maxScrollLeft = list.scrollWidth - list.clientWidth;

  navigationButtons.forEach((navigationButton) => {
    const isVisible =
      navigationButton.dataset.direction === 'left'
        ? list.scrollLeft > 1
        : list.scrollLeft < maxScrollLeft - 1;

    if (isVisible) {
      addClassToElement(navigationButton, classes.is.visible);
    } else {
      removeClassToElement(navigationButton, classes.is.visible);
    }
  });
};

// Export
export { listenVideoProductsCarousel };
